import { MouseEvent, useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import TagManager, { DataLayerArgs } from 'react-gtm-module'
import { Link, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import 'swiper/css'
import 'swiper/css/free-mode'
import { FreeMode } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { PropsType } from '../../@types/etc'
import { SectionDetailType } from '../../@types/home'
import { getCategoryProductReview, getReviewBoards, getSectionsDetail } from '../../api/home'
import { getReviewDetail } from '../../api/product'
import { AFWebLinkType, RNPostMessage, sendSetAppsflyerEvent } from '../../js/postMessage'
import { plusComma } from '../../js/script'
import { imgURL } from '../Footer'
import { useAppContext } from '../provider/AppProvider'

export default function CategoryReview({ el, index, category }: PropsType) {
  const [sectionItem, setSectionItem] = useState<SectionDetailType>()
  const [reviewItem, setReviewItem] = useState<any>([])
  const [categoryItem, setCategoryItem] = useState<any>([])
  const [selectCategory, setSelectCategory] = useState<any>()
  const [isTouchMoving, setIsTouchMoving] = useState<boolean>(false)
  const { isAppView } = useAppContext()

  useEffect(() => {
    getSectionsDetail(el.sectionNo)
      .then((res) => {
        if (res.data && res.data.length > 0) {
          setSectionItem(res.data) // 데이터를 한 번에 업데이트
        }
      })
      .catch((err) => console.log(err))
  }, [])
  //카테고리중 낚시용품만 뽑기
  useEffect(() => {
    if (category) {
      category?.multiLevelCategories?.map((el: any) => {
        if (el.label === '낚시용품') {
          setCategoryItem(el.children)
          setSelectCategory(el.children[0])
        }
      })
    }
  }, [category])
  //카테고리에 등록된 상품평 가져오기
  useEffect(() => {
    if (selectCategory) {
      getCategoryProductReview(selectCategory?.categoryNo)
        .then((res) => {
          setReviewItem(res.data.items)
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }, [selectCategory])

  function scrollToButton(a: EventTarget & HTMLAnchorElement) {
    const horizontalScroll = document.getElementById('horizontal_scroll2')
    if (!horizontalScroll) {
      return
    }

    const buttonRect = a.getBoundingClientRect()
    const menuRect = horizontalScroll.getBoundingClientRect()

    if (buttonRect.left < menuRect.left || buttonRect.right > menuRect.right) {
      horizontalScroll.scrollTo({
        left:
          a.getBoundingClientRect().x -
          horizontalScroll.getBoundingClientRect().x -
          horizontalScroll.clientWidth / 2 +
          a.clientWidth / 2,
        behavior: 'smooth',
      })
    }
  }

  const touchMove = () => {
    setIsTouchMoving(true)
  }

  const touchEnd = () => {
    setIsTouchMoving(false)
  }

  return (
    <div
      className='category_review'
      onClick={(): void => {
        const gtmNavigateClick: DataLayerArgs = {
          dataLayer: {
            event: 'select_content',
            event_info: {
              content_type: '홈모듈',
              content_id: String(el.sectionNo),
              content_name: el.sectionName,
            },
          },
        }
        if (isAppView) {
          sendSetAppsflyerEvent({
            eventName: 'select_content',
            eventType: {
              content_type: '홈모듈',
              content_id: String(el.sectionNo),
              content_name: el.sectionName,
            },
          })
        } else {
          TagManager.dataLayer(gtmNavigateClick)
        }
      }}
    >
      <div className='home_module_title'>
        <p>{sectionItem?.promotionText}</p>
        <p>
          <strong>{sectionItem?.sectionExplain}</strong>
        </p>
      </div>
      <div className='tab_wrap'>
        <SwiperWrap
          slidesPerView={'auto'}
          spaceBetween={4}
          breakpoints={{
            768: {
              spaceBetween: 8,
            },
          }}
          modules={[FreeMode]}
          freeMode={false}
          centeredSlidesBounds={true}
          slideToClickedSlide={true}
          onTouchMove={touchMove}
          onTouchEnd={touchEnd}
        >
          {categoryItem.map((el: any, idx: number) => {
            return (
              <SwiperSlideItem key={idx}>
                <div
                  className={selectCategory?.categoryNo === el?.categoryNo ? 'on' : ''}
                  onTouchEnd={(): void => {
                    if (isMobile && !isTouchMoving) {
                      setSelectCategory(el)
                    }
                  }}
                  onClick={(): void => {
                    if (!isMobile) {
                      setSelectCategory(el)
                    }
                  }}
                  key={el.categoryNo}
                >
                  <a
                    href='#'
                    onClick={(e: MouseEvent<HTMLAnchorElement>): void => {
                      e.preventDefault()
                      scrollToButton(e.currentTarget)
                    }}
                  >
                    {el.label}
                  </a>
                </div>
              </SwiperSlideItem>
            )
          })}
        </SwiperWrap>
      </div>
      <div className='category_review_list'>
        {reviewItem?.length !== 0 ? (
          <ul>
            {reviewItem?.map((el: any) => {
              return <MemberReviewItem el={el} key={el.reviewNo}></MemberReviewItem>
            })}
          </ul>
        ) : (
          <div className='no_data'>
            <img src={`${imgURL}/empty_logo.png`} alt='' />
            <p>리뷰가 없습니다.</p>
          </div>
        )}
      </div>
      {index !== 0 && <hr />}
    </div>
  )
}

function MemberReviewItem({ el }: any) {
  const { isAppView } = useAppContext()
  const navigate = useNavigate()

  const [productItem, setProductItem] = useState<any>()
  const [reviewDetail, setReviewDetail] = useState<any>()
  useEffect(() => {
    getReviewBoards()
      .then((res) => {
        res.data.items.map((element: any) => {
          element.reviews.map((ele: any) => {
            if (ele.reviewNo === el.reviewNo) {
              setProductItem(element)
            }
          })
        })
      })
      .catch((err) => console.log(err))
  }, [el])

  useEffect(() => {
    if (productItem) {
      getReviewDetail(productItem.productNo, el.reviewNo)
        .then((res) => {
          setReviewDetail(res.data.registerYmdt)
        })
        .catch((err) => console.log(err))
    }
  }, [productItem])

  return (
    <li key={el.productNo}>
      <div className='category_review_wrap'>
        <div className='contents_wrap'>
          <div className='item_img'>
            <div
              onClick={() => {
                if (isAppView) {
                  RNPostMessage(AFWebLinkType.moveToLink, {
                    url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/product/${el.productNo}`,
                  })
                } else {
                  navigate(`/product/${el.productNo}`)
                }
              }}
              style={{
                display: 'block',
                width: isMobile ? '90px' : '100px',
                height: isMobile ? '90px' : '100px',
                backgroundImage: `url(${el?.imageUrl})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                boxShadow: '0px 0px 0px 1px rgba(0, 0, 0, 0.05) inset',
                borderRadius: '6px',
                overflow: 'hidden',
              }}
            ></div>
          </div>
          <div className='review_txt_wrap'>
            <div className='star_rating'>
              <div>
                <img src={`${imgURL}/star.svg`} alt='' />
                <img src={`${imgURL}/star.svg`} alt='' />
                <img src={`${imgURL}/star.svg`} alt='' />
                <img src={`${imgURL}/star.svg`} alt='' />
                <img src={`${imgURL}/star_off.svg`} alt='' />
              </div>
              <span>{el?.reviewRate}</span>
            </div>
            <div className='category_review_txt'>
              <div
                onClick={() => {
                  if (isAppView) {
                    RNPostMessage(AFWebLinkType.moveToLink, {
                      url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/product/${el.productNo}`,
                    })
                  } else {
                    navigate(`/product/${el.productNo}`)
                  }
                }}
              >
                {el?.content}
              </div>
            </div>
            <div className='member_info'>
              <p className='name'>{el?.nickname}</p>
              <p className='date'>
                {reviewDetail?.split(' ', 1).join('').replaceAll('-', '. ').replaceAll('. 0', '. ')}
              </p>
            </div>
          </div>
        </div>
        <div className='item_txt_wrap'>
          <div
            onClick={() => {
              if (isAppView) {
                RNPostMessage(AFWebLinkType.moveToLink, {
                  url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/product/${el.productNo}`,
                })
              } else {
                navigate(`/product/${el.productNo}`)
              }
            }}
          >
            <div className='item_title'>{el?.orderedOption?.optionValue}</div>
            <div className='item_sale'>
              {Math.floor(
                ((productItem?.salePrice - productItem?.appliedImmediateDiscountPrice) / productItem?.salePrice) * 100
              ) !== 0 && (
                <span className='percent'>
                  {Math.floor(
                    ((productItem?.salePrice - productItem?.appliedImmediateDiscountPrice) / productItem?.salePrice) *
                      100
                  )}
                  %
                </span>
              )}
              <span className='price'>{plusComma(productItem?.appliedImmediateDiscountPrice)}원</span>
            </div>
          </div>
        </div>
      </div>
    </li>
  )
}

export const SwiperWrap = styled(Swiper)`
  padding: 0 18px;
  @media screen and (min-width: 768px) {
    padding: 0;
  }
`
export const SwiperSlideItem = styled(SwiperSlide)`
  width: auto !important;
  & .on {
    & a {
      color: var(--colWhite);
      background: var(--colPointBlue);
      border: 1px transparent solid;
    }
  }
  & a {
    display: block;
    color: var(--colGray6);
    background: var(--colWhite);
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    word-break: keep-all;
    height: 32px;
    border-radius: 32px;
    border: 1px var(--colGray3) solid;
    padding: 8px 14px;
    white-space: nowrap;
  }
  @media screen and (min-width: 768px) {
    & .on {
      & a {
        color: var(--colWhite);
        background: var(--colPointBlue);
        border: 1px transparent solid;
      }
    }
    & a {
      display: block;
      color: var(--colGray6);
      background: var(--colWhite);
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      word-break: keep-all;
      height: 40px;
      border-radius: 32px;
      border: 1px var(--colGray3) solid;
      padding: 10px 16px;
      white-space: nowrap;
    }
  }
`
